export const notifications = [
  {
    image: "https://via.placeholder.com/150x150",
    title: "La Dra. Julia Ramirez tiene un nuevo paciente para tratamiento",
    time: "4:10 PM",
    icon: "zmdi-alert-triangle text-orange",
  },
];
